import React from "react";
import { Box, Typography, Button } from "@mui/material";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { useNavigate } from "react-router-dom";
import { useKivunovaTranslation } from "@kivunova/kivufrontendcommon";

const NoProductItemDetailFound: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useKivunovaTranslation();

  return (
    <Box
      sx={{
        p: 5,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        height: "70vh",
        color: "black"
      }}
    >
      <Typography color="textPrimary" variant="h5" fontWeight="bold" mb={2}>
        {t("no-product-item-detail-found-title", "Product Item not found")}
      </Typography>
      <Typography color="text.secondary" mb={3}>
        {t(
          "no-product-item-detail-found.description",
          "The product item you're looking for doesn't exist or has been removed."
        )}
      </Typography>
      <Button
        variant="contained"
        startIcon={<ArrowBackOutlinedIcon />}
        onClick={() => navigate(-1)}
      >
        {t("no-product-item-detail-found-back-button", "Go Back")}
      </Button>
    </Box>
  );
};

export default NoProductItemDetailFound;
